import { Grid, Text } from '@chakra-ui/react'
import { Fragment } from 'react'

export interface EmailSenderPreviewProps {
  /** Display name of the From mailbox (acting user's full name). */
  senderName?: string
  /** Address of the From mailbox (OU sender address or the user's own). */
  senderAddress?: string
  /** Reply-To address (acting user's own e-mail). */
  replyAddress?: string
  /** Subject. Omit where the subject is already shown elsewhere. */
  subject?: string
}

const Row = ({ label, value }: { label: string, value?: string }) =>
  value
    ? (
      <Fragment>
        <Text fontSize='sm' color='gray.500'>{label}</Text>
        <Text fontSize='sm' color='gray.700' fontWeight='medium' wordBreak='break-word'>{value}</Text>
      </Fragment>
      )
    : null

/**
 * Read-only summary of how an outgoing e-mail will appear to the recipient: From (name +
 * address), Reply-To and optionally the subject. Shown in the Send Calculation / Send Contract
 * modals.
 */
export const EmailSenderPreview = ({ senderName, senderAddress, replyAddress, subject }: EmailSenderPreviewProps) => {
  if (!senderAddress && !replyAddress && !subject)
    return null

  return (
    <Grid templateColumns='max-content 1fr' columnGap={4} rowGap={1} pt={3} mt={1} borderTopWidth='1px' borderColor='gray.100'>
      <Row label='Odesílatel' value={senderName && senderAddress ? `${senderName} <${senderAddress}>` : senderAddress} />
      <Row label='Adresa pro odpověď' value={replyAddress !== senderAddress ? replyAddress : undefined} />
      <Row label='Předmět' value={subject} />
    </Grid>
  )
}
